export default "__VITE_ASSET__BFmceSw9__"